import IconLicense, {
	IconLicenseProps as _IconLicenseProps,
} from './IconLicense';

export { IconLicense };
export type IconLicenseProps = _IconLicenseProps;
